import { VacancyListPage } from '@pages/vacancy';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Вакансии', 'Управление вакансиями');
}

export default VacancyListPage;
